'use strict';
var ajaxHandler = require('./ajaxHandler');
var dateUtils = require('../utils/dateUtils');
var assertType = require('../utils/asserts').assertType;

/**
 * Get allowed values for policy start date for given employeeGroup and productType
 * returns values in user format
 */
function getPolicyStartDate(employeeGroupId, productType) {
    assertType(employeeGroupId, 'string', 'Invalid employeeGroup value '+ employeeGroupId +'- expected string');
    assertType(productType, 'string', 'Invalid productType value '+ productType +'- expected string');
    return ajaxHandler.ajaxGetJson({url: process.env.contextRoot + '/rest/dates/startDates?categoryId=' + employeeGroupId + '&productType=' + productType})
        .then(function (data){
            var result = {};
            if (data.minStartDate) {
                result.minStartDate = dateUtils.format2user(data.minStartDate);
            }
            if (data.maxStartDate) {
                result.maxStartDate = dateUtils.format2user(data.maxStartDate);
            }
            if (data.excludedDates) {
                var excludedDates = [];
                data.excludedDates.forEach(function (dt) {
                    var newDt = dateUtils.format2user(dt);
                    excludedDates.push(newDt);
                });
                result.excludedDates = excludedDates;
            }
            result.renewalDateInStartDateWindow = data.renewalDateInStartDateWindow;
            return result;
        })
        .fail(ajaxHandler.handleError('Could not retrieve product type dates'));
}

module.exports.getPolicyStartDate = getPolicyStartDate;


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/services/startDatesService.js
// module id = iyeL
// module chunks = 2